const LEFT_COUNT = 'leftCount';
const RIGHT_COUNT = 'rightCount';

const answerAreaKeyword = [ '\\boxed', '\\enclose{circle}', '{{}}' ];

const useLaTexCode = () => {

  const getEndScope = ( code, point=0, sliceCountL=0, sliceCountR=0 ) => {
    const startPoint = code.slice( point ).indexOf( '{' );
    const endPoint = code.slice( point ).indexOf( '}' );
    let shift;
    if ( sliceCountL && sliceCountR && sliceCountL === sliceCountR ) {
      return point;
    }
    switch ( true ) {
      case startPoint > -1 && endPoint > -1 :
        shift = startPoint < endPoint ? LEFT_COUNT : RIGHT_COUNT;
        break;
      case startPoint > -1 && endPoint === -1 :
        shift = LEFT_COUNT;
        break;
      case startPoint === -1 && endPoint > -1 :
        shift = RIGHT_COUNT;
        break;
    }
    switch ( shift ) {
      case LEFT_COUNT :
        return getEndScope( code, point + startPoint + 1, sliceCountL + 1, sliceCountR );
      case RIGHT_COUNT :
        return getEndScope( code, point + endPoint + 1, sliceCountL, sliceCountR + 1 );
    }
  };

  const getLaTexCodeParts = ( code, result=[] ) => {
    const reduceData = ( result, value ) => {
      const slicePoint = code.indexOf( value );
      return -1 < slicePoint && result.slicePoint > slicePoint ? { slicePoint, prevCode : code.slice( 0, slicePoint + value.length ) } : result;
    };
    const data = answerAreaKeyword.reduce( reduceData, { slicePoint : code.length } );
    if ( data.prevCode ) {
      const nextCode = code.slice( data.prevCode.length );
      return getLaTexCodeParts( nextCode.slice( getEndScope( nextCode ) ), [ ...result, data.prevCode ] );
    } else {
      return [ ...result, code ];
    }
  };

  const correctImgCode = ( code ) => {
    const splittedCode = code.split( '\\img' );
    if ( 1 < splittedCode.length ) {
      return splittedCode.map( ( v, i ) => i ? correctImgCodeParams( v ) : v ).join( '\\img' );
    } else {
      return code;
    }
  };

  const correctImgCodeParams = ( code, count=0 ) => {
    if ( 2 < count ) {
      return code;
    }
    const startScopeIndex = code.indexOf( '[' ) + 1;
    if ( 0 === startScopeIndex ) {
      return code;
    }
    const startScope = code.slice( 0, startScopeIndex );
    const startScopeNextCode = code.slice( startScopeIndex );
    if ( 0 !== startScope.trim().indexOf( '[' ) ) {
      return `${ startScope }${ startScopeNextCode }`;
    }
    const endScopeIndex = startScopeNextCode.indexOf( ']' );
    if ( -1 === endScopeIndex ) {
      return `${ startScope }${ startScopeNextCode }`;
    }
    const originValue = startScopeNextCode.slice( 0, endScopeIndex );
    const splittedOriginValue = originValue.trim().split( 'px' );
    const value = ( 2 === splittedOriginValue.length ) && Number( splittedOriginValue[ 0 ] ) && ! splittedOriginValue[ 1 ] ? originValue : '';
    const valueNextCode = startScopeNextCode.slice( endScopeIndex );
    const endScope = valueNextCode.slice( 0, 1 );
    const endScopeNextCode = valueNextCode.slice( 1 );
    return `${ startScope }${ value }${ endScope }${ correctImgCodeParams( endScopeNextCode, count + 1 ) }`;
  };

  return {
    getEndScope,
    getLaTexCodeParts,
    correctImgCode
  };

};

export default useLaTexCode;
